<div class="relative">
  <p-toast></p-toast>

  <div class="z-5 sticky top-0 left-0 w-full font-bold">
    <app-header />
  </div>
  <div class="page-content p-4 md:p-6 lg:p-8">
    <router-outlet />
  </div>
</div>
